import FlightListCard from "./FlightListCard";

export default FlightListCard;